import { createHttpEndpoint } from '../../utils'

import type {
  GetAddressRules,
  GetAddresses,
  PostAddressRule,
} from './address.types'

/**
 * Retrieve address rules as an authenticated merchant.
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/seller-merchants-api/definition#tag/Address/operation/get-bm-merchants-address-rules}
 */
export const getAddressRules = createHttpEndpoint<GetAddressRules>({
  method: 'GET',
  operationId: 'getAddressRules',
  path: '/bm/merchants/address-rules',
})

/**
 * Create an address rule as an authenticated merchant.
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/seller-merchants-api/definition#tag/Address/operation/post-bm-merchants-address-rules}
 */
export const postAddressRule = createHttpEndpoint<PostAddressRule>({
  method: 'POST',
  operationId: 'createAddressRule',
  path: '/bm/merchants/address-rules',
})

/**
 * Edit an address rule as an authenticated merchant.
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/seller-merchants-api/definition#tag/Address/operation/put-bm-merchants-address-rules-id}
 */
export const putAddressRule = createHttpEndpoint({
  method: 'PUT',
  operationId: 'editAddressRule',
  path: '/bm/merchants/address-rules/:id',
})

/**
 * Delete an address rule as an authenticated merchant.
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/seller-merchants-api/definition#tag/Address/operation/delete-bm-merchants-address-rules-id}
 */
export const deleteAddressRule = createHttpEndpoint({
  method: 'DELETE',
  operationId: 'deleteAddressRule',
  path: '/bm/merchants/address-rules/:id',
})

/**
 * Retrieve addresses as an authenticated merchant.
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/seller-merchants-api/definition#tag/Address/operation/get-bm-merchants-addresses}
 */
export const getAddresses = createHttpEndpoint<GetAddresses>({
  method: 'GET',
  operationId: 'getAddresses',
  path: '/bm/merchants/addresses',
})

/**
 * Create an address as an authenticated merchant.
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/seller-merchants-api/definition#tag/Address/operation/post-bm-merchants-addresses}
 */
export const postAddress = createHttpEndpoint({
  method: 'POST',
  operationId: 'createAddress',
  path: '/bm/merchants/addresses',
})

/**
 * Edit an address as an authenticated merchant.
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/seller-merchants-api/definition#tag/Address/operation/put-bm-merchants-addresses-id}
 *
 * TODO Update API specs, which indicate PUT instead of PATCH
 */
export const patchAddress = createHttpEndpoint({
  method: 'PATCH',
  operationId: 'editAddress',
  path: '/bm/merchants/addresses/:id',
})

/**
 * Delete an address as an authenticated merchant.
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/seller-merchants-api/definition#tag/Address/operation/delete-bm-merchants-addresses-id}
 */
export const deleteAddress = createHttpEndpoint({
  method: 'DELETE',
  operationId: 'deleteAddress',
  path: '/bm/merchants/addresses/:id',
})

/**
 * Set my default address as an authenticated merchant.
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/seller-merchants-api/definition#tag/Address/operation/post-bm-merchants-addresses-set-default-address}
 */
export const postSetDefaultAddress = createHttpEndpoint({
  method: 'POST',
  operationId: 'setDefaultAddress',
  path: '/bm/merchants/addresses/:id/set-default-address',
})
